import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // HCA (Parent + Child)
  getHcaAffiliation(rcmId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}hcaAffiliationChain`,
      {
        rcm_id: rcmId
      },
      {
        withCredentials: true
      }
    );
  }

  // HCP (Child)
  getHcpAffiliation(rcmId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}hcpParentOptions`,
      {
        rcm_id: rcmId
      },
      {
        withCredentials: true
      }
    );
  }

  getHcaHierarchyChain(rcmId: string): Observable<any> {
  return this.http.post(
    `${this.baseUrl}hcaHierarchyChain`,
    {
      rcm_id: rcmId
    },
    {
      withCredentials: true
    }
  );
}
getProfileByRcmId(rcmId: string) {
  return this.http.get(`${environment.apiUrl}/search/${rcmId}`);
}
//  getSearchProfile(params: Obj): Observable<SearchColumnResults> {
//     return this.httpService.post('search', params);
//   }
}